import axios from "axios";
import { END_POINT } from "../constants/defaultValues";

const readLocalStorage = (key, fallback = "") => {
  if (typeof window === "undefined" || !window.localStorage) return fallback;
  const value = window.localStorage.getItem(key);
  return value === null || value === "null" || value === "undefined"
    ? fallback
    : value;
};

const parseJson = (value) => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

export const buildStoredAuthPayload = () => ({
  user: {
    id: readLocalStorage("user_id"),
    idParent: readLocalStorage("b") || readLocalStorage("user_id"),
    username: readLocalStorage("username"),
    companyUUID: readLocalStorage("companyUUID"),
    fullname: readLocalStorage("fullname"),
    companyName: readLocalStorage("companyName"),
    companyAddress: readLocalStorage("companyAddress"),
    companyWebsite: readLocalStorage("companyWebsite"),
    companyImage: readLocalStorage("companyImage"),
    companyLogo: readLocalStorage("companyLogo"),
    hotline: readLocalStorage("hotline"),
    namePay: readLocalStorage("namePay"),
    numberPay: readLocalStorage("numberPay"),
    bankPay: readLocalStorage("bankPay"),
    image: readLocalStorage("avatar"),
    businessType: readLocalStorage("businessType"),
  },
  roleSettings: parseJson(readLocalStorage("roleSettings")),
});

export const applyAuthPayload = (authData) => {
  if (!authData) return false;

  if (authData.token) {
    localStorage.setItem("access_token", authData.token);
  }

  if (authData.user) {
    const user = authData.user;
    localStorage.setItem("user_id", user.id || "");
    localStorage.setItem("b", user.idParent || user.id || "");
    localStorage.setItem("username", user.username || "");
    localStorage.setItem("avatar", user.image || "");
    localStorage.setItem("companyUUID", user.companyUUID || "");
    localStorage.setItem("companyAddress", user.companyAddress || "");
    localStorage.setItem("companyName", user.companyName || "");
    localStorage.setItem("companyImage", user.companyImage || "");
    localStorage.setItem("companyWebsite", user.companyWebsite || "");
    localStorage.setItem("companyLogo", user.companyLogo || "");
    localStorage.setItem("fullname", user.fullname || user.username || "");
    localStorage.setItem("hotline", user.hotline || "");
    localStorage.setItem("namePay", user.namePay || "");
    localStorage.setItem("numberPay", user.numberPay || "");
    localStorage.setItem("bankPay", user.bankPay || "");
    localStorage.setItem("businessType", user.businessType || "");
  }

  if (authData.roleSettings) {
    localStorage.setItem("roleSettings", JSON.stringify(authData.roleSettings));
  }

  return true;
};

export const createAuthHandoff = async (payload = buildStoredAuthPayload()) => {
  const token = readLocalStorage("access_token");
  if (!token) {
    throw new Error("Missing access token for auth handoff");
  }

  const response = await axios.post(
    `${END_POINT}/auth/handoff`,
    { payload },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.data || !response.data.handoff) {
    throw new Error("Auth handoff was not created");
  }

  return response.data.handoff;
};

export const appendAuthHandoff = (targetUrl, handoff) => {
  const url = new URL(targetUrl, window.location.origin);
  url.searchParams.set("handoff", handoff);
  return url.toString();
};

export const createAuthHandoffUrl = async (targetUrl, payload) => {
  const handoff = await createAuthHandoff(payload);
  return appendAuthHandoff(targetUrl, handoff);
};

export const exchangeAuthHandoffFromUrl = async () => {
  const params = new URLSearchParams(window.location.search);
  const handoff = params.get("handoff");
  const legacyAuth = params.get("auth");

  if (!handoff && legacyAuth) {
    params.delete("auth");
    const cleanUrl =
      window.location.pathname +
      (params.toString() ? `?${params.toString()}` : "") +
      window.location.hash;
    window.history.replaceState({}, document.title, cleanUrl);
    return false;
  }

  if (!handoff) return false;

  const response = await axios.get(
    `${END_POINT}/auth/handoff/${encodeURIComponent(handoff)}`,
  );
  const applied = applyAuthPayload(response.data);

  params.delete("handoff");
  params.delete("auth");
  const cleanUrl =
    window.location.pathname +
    (params.toString() ? `?${params.toString()}` : "") +
    window.location.hash;
  window.history.replaceState({}, document.title, cleanUrl);

  if (applied) {
    window.location.reload();
  }

  return applied;
};
